import $ from 'jquery'
import AccountWorkflowFilter from './../handlers/working-screen/account_workflow_filter'
import AccountStatuses from './../handlers/working-screen/account_statuses'
import ToggleAccountGroup from './../handlers/working-screen/toggle_account_group'

let instances = []

// AccountStatuses subscribes to MessageBus and AccountWorkflowFilter binds a
// $(document) click handler — both outlive the replaced frame DOM, so tear the
// current set down before re-running setup() or navigating away.
const teardownInstances = () => {
  instances.forEach((instance) => instance.destroy?.())
  instances = []
}

const setup = () => {
  teardownInstances()

  const parent = $('[data-behaviour~="workflow-account-list"]')
  if (parent.length === 0) {
    return
  }

  const $accountList = $('[data-behaviour~="filtered-workflow-account-list"]')

  const $filterWrapper = $(
    '[data-behaviour~="workflow-account-filter-wrapper"]'
  )

  const cachedData = parent.data('cached-data')

  // Order of initializers is important, AccountWorkflowFilter should be defined before AccountStatuses, because it's listening on second one events that can be triggered immediately
  instances = [
    new AccountWorkflowFilter($accountList, $filterWrapper),
    new AccountStatuses($accountList, $filterWrapper, cachedData),
    new ToggleAccountGroup($accountList, $filterWrapper),
  ]
}

// setup() only runs once the lazily-loaded ledger_table frame arrives.
const onFrameLoad = (event) => {
  if (event.target?.id !== 'ledger_table') return

  setup()
}

document.addEventListener('turbo:frame-load', onFrameLoad)
document.addEventListener('turbolinks:visit', teardownInstances)
